import styles from "@css/modules/Resort.module.scss"
import React, { useMemo } from "react"
import { useMediaQuery } from "@utils/hooks/useMediaQuery"
import { Picture } from "../../Picture"
import { SlideAppear } from "../../Animation/SlideAppear"

const requireImage = require.context("../images/", false, /\.(png|webp)$/)

export function Partners({ resort, onChange, selectedId }) {
    const internalMobile = useMediaQuery("(max-width: 575px)")
    const imgIndex = resort.id === selectedId ? 0 : 1
    const { img, imgWebp } = useMemo(() => {
        if (!resort.partner) {
            return {}
        }
        const imgDesktop = requireImage(`./${resort.slug}-partner-${imgIndex}.png`)
        const imgMobile = requireImage(`./${resort.slug}-mobile-partner-${imgIndex}.png`)
        const imgDesktopWebp = requireImage(`./${resort.slug}-partner-${imgIndex}.webp`)
        const imgMobileWebp = requireImage(`./${resort.slug}-mobile-partner-${imgIndex}.webp`)
        const img = internalMobile ? imgMobile.default : imgDesktop.default
        const imgWebp = internalMobile ? imgMobileWebp.default : imgDesktopWebp.default
        return {
            img,
            imgWebp
        }
    }, [resort, imgIndex, internalMobile])
    if (!resort.partner) {
        return null
    }

    const partner = resort.partner
    return (
        <SlideAppear className={styles.partnerRoot}>
            <div className={styles.partnerHead}>
                <div className={selectedId === resort.id ? styles.activeHead : undefined} onClick={() => onChange(resort)}>
                    {resort.partnerTitle}
                </div>
                <div className={selectedId === partner.id ? styles.activeHead : undefined} onClick={() => onChange(partner)}>
                    {partner.partnerTitle}
                </div>
            </div>
            <Picture
                webpSrc={imgWebp.src}
                defaultSrc={img.src}
                width={img.width}
                height={img.height}
                alt={resort.short_name}
                className={styles.overPartnerImg}
                imgClassName={styles.partnerImage}
            />
        </SlideAppear>
    )
}
